// extracted by mini-css-extract-plugin
export var chevron = "_gl-4";
export var chevronExpanded = "_gl-5";
export var row = "_gl-0";
export var rowBody = "_gl-6";
export var rowDescription = "_gl-7";
export var rowHeader = "_gl-1";
export var rowTitle = "_gl-2";
export var rowTitleComplete = "_gl-3";